import { render } from "./Findvowels.vue?vue&type=template&id=7e17b79c&scoped=true&ts=true"
import script from "./Findvowels.vue?vue&type=script&lang=ts"
export * from "./Findvowels.vue?vue&type=script&lang=ts"

import "./Findvowels.vue?vue&type=style&index=0&id=7e17b79c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e17b79c"]])

export default __exports__